const DEFAULT_LOCALE = 'en';
const LOCALE_COOKIE = 'userLocale';
const LOCALE_LABELS = {
    'en-US': 'English',
    en: 'English',
    nl: 'Nederlands',
    fr: 'Français',
    de: 'Deutsch',
    es: 'Español',
    it: 'Italiano',
    pt_BR: 'Português',
    pt: 'Português',
    ja_JP: '日本語',
    ja: '日本語',
    ko: '한국어',
    ar: 'العربية',
    ru: 'Русский',
    tr: 'Türkçe',
    th: 'ไทย',
    pl: 'Polski',
    sv: 'Svenska',
    fi: 'Suomi',
    nb: 'Norsk',
    da: 'Dansk'
};
const RTL_LANGUAGES = [
    'ar',
    'he'
];

export { DEFAULT_LOCALE, LOCALE_COOKIE, LOCALE_LABELS, RTL_LANGUAGES };
